import { Controller } from "@hotwired/stimulus";

// Catalogue des crédits SMS (GO4SMS) : on choisit une QUANTITÉ ; la tranche
// (min/max) donne le prix unitaire. L'estimation est indicative (HT/TTC) — le
// chiffrage qui fait foi, frais opérateur compris, est celui de la page de
// paiement (serveur). « Continuer » y envoie le panier { sms: n }.
export default class extends Controller {
  static targets = ["input", "estimate", "tier", "total", "after", "error", "submit", "cart", "preset"];
  static values = { tiers: Array, balance: Number, labels: Object, itemId: String };

  connect() {
    this.refresh();
  }

  preset(event) {
    this.inputTarget.value = event.currentTarget.dataset.quantity;
    this.refresh();
  }

  refresh() {
    const quantity = parseInt(this.inputTarget.value, 10) || 0;
    const tier = this.tierFor(quantity);
    const l = this.labelsValue;

    this.presetTargets.forEach((btn) => {
      const active = parseInt(btn.dataset.quantity, 10) === quantity;
      btn.classList.toggle("ds-chip--success", active);
      btn.classList.toggle("ds-chip--neutral", !active);
    });

    this.cartTarget.value = JSON.stringify({ [this.itemIdValue]: quantity });
    this.submitTarget.disabled = !tier;
    this.estimateTarget.classList.toggle("hidden", !tier);
    this.errorTarget.classList.toggle("hidden", Boolean(tier) || quantity === 0);
    if (!tier) return;

    const ht = quantity * tier.unit_ht;
    const ttc = Math.ceil(ht * (1 + tier.tva / 100));
    this.tierTarget.textContent = l.tier
      .replace("__TIER__", tier.label)
      .replace("__PRICE__", this.format(tier.unit_ht, 2));
    this.totalTarget.textContent = l.total
      .replace("__HT__", this.format(ht))
      .replace("__TTC__", this.format(ttc));
    this.afterTarget.textContent = l.after.replace("__SMS__", this.format(this.balanceValue + quantity));
  }

  tierFor(quantity) {
    if (quantity <= 0) return null;
    return this.tiersValue
      .filter((t) => quantity >= t.min && (t.max === null || quantity <= t.max))
      .sort((a, b) => b.min - a.min)[0] || null;
  }

  format(n, digits = 0) {
    return Number(n).toLocaleString("fr-FR", { maximumFractionDigits: digits }).replace(/ | /g, " ");
  }
}
